module.exports = __webpack_public_path__ + "img/linkedin.70e3cfc7.png";